import React from "react";
import {
  TerminalsTilesLoadingStatusSummary,
} from "../../../app/data/terminal-summary/terminalTiles/TerminalsTilesModel";
import {
  TerminalSummaryTile,
  TerminalSummaryTileTypes,
} from "./terminalSummaryTile";
import "./terminalSummarytile.scss";
import { OriginalCounts } from "app/data/terminal-summary/TerminalListModel";

interface TerminalSummaryProps {
  terminalSummary: OriginalCounts | null;
  region: TerminalsTilesLoadingStatusSummary["regionCount"];
  isLoading: boolean;
  clickedStates: {
    xgs: boolean;
    agents: boolean;
    rlm: boolean;
  };
  setClickedStates: (states: {
    xgs: boolean;
    agents: boolean;
    rlm: boolean;
  }) => void;
  handleTerminals: (type: string) => void;
  handleClear: () => void;
}

export const TerminalSummaryCount: React.FC<TerminalSummaryProps> = ({
  terminalSummary,
  region,
  isLoading,
  clickedStates,
  setClickedStates,
  handleTerminals,
  handleClear
}) => {
  const handleClick = (key: keyof typeof clickedStates, type: string) => {
    setClickedStates({ xgs: false, agents: false, rlm: false, [key]: true });
    handleTerminals(type);
  };

  const onClear = (key: keyof typeof clickedStates) => {
    setClickedStates({ xgs: false, agents: false, rlm: false, [key]: false });
    handleClear();
  };

  const tiles = [
    {
      key: "xgs",
      type: TerminalSummaryTileTypes.totalTerminals,
      title: "XGS Terminals",
      value: terminalSummary?.originalXgsCount ?? "0",
      onClick: () => handleClick("xgs", "XGS Terminal"),
      clicked: clickedStates.xgs,
      onClear: () => onClear("xgs"),
    },
    {
      key: "agents",
      type: TerminalSummaryTileTypes.activeAgents,
      title: "Agents Terminals",
      value: terminalSummary?.originalAgentCount ?? "0",
      onClick: () => handleClick("agents", "Agent Terminal"),
      clicked: clickedStates.agents,
      onClear: () => onClear("agents"),
    },
    {
      key: "rlm",
      type: TerminalSummaryTileTypes.distributors,
      title: "WG locations",
      value: terminalSummary?.originalRlmCount ?? "0",
      onClick: () => handleClick("rlm", "WG Locations"),
      clicked: clickedStates.rlm,
      onClear: () => onClear("rlm"),
    },
    {
      key: "regions",
      type: TerminalSummaryTileTypes.regions,
      title: "Regions",
      value: region ?? "0",
      onClick: undefined,
      clicked: false,
    },
  ];

  return (
    <div className="xgs-terminaltiles-summary">
      {tiles.map((tile) => (
        <TerminalSummaryTile
          key={tile.key}
          type={tile.type}
          isLoading={isLoading}
          title={tile.title}
          value={tile.value}
          clicked={tile.clicked}
          onClick={tile.onClick}
          onClear={tile.onClear}
        />
      ))}
    </div>
  );
};
